import React, {Component} from 'react';

class Slider extends Component {
  render(){
    return(
      <div id="slider">
        <h2>We turn 50's and 60's radios <br /> into bluetooth or WiFi devices</h2>
      </div>
    )
  }
}

export default Slider;


// WEBPACK FOOTER //
// ./src/components/Slider.js